// extracted by mini-css-extract-plugin
export var bg = "ResidenceClub-module--bg--31677";
export var core = "ResidenceClub-module--core--2f14c";